// extracted by mini-css-extract-plugin
module.exports = {"title":"dece2e673c--title--k7tw6","load-more-button":"dece2e673c--load-more-button--YeKbS"};